module.exports = __webpack_public_path__ + "img/pic6.87f21ea2.png";